<template>
  <div>
    <div class="pr-4 pb-4">
      <v-row>
        <v-col cols="12">
          <v-text-field
            light
            label="Title"
            v-model="item.name"
            type="text"
            required
            color="amber"
            placeholder="Name"
          ></v-text-field>
          <v-textarea
            light
            label="Body"
            color="amber"
            v-model.trim="item.body"
            :rows="2"
            :autoGrow="true"
            :hide-details="true"
        /></v-col>
        <v-col cols="6">
          <v-select
            light
            :items="colors"
            label="Colour code"
            :value="item.color"
            v-model.trim="item.color"
            item-text="title"
            item-value="color"
          ></v-select>
          <v-select
            :items="local.categories"
            label="Categories"
            multiple
            v-model.trim="item.categories"
            light
          ></v-select>
          <v-select
            :items="brandItems"
            label="Brand"
            v-model="item.brand"
            light
          ></v-select>
        </v-col>
        <v-col cols="6">
          <v-select
            :items="endorsementItems"
            label="Endorsement"
            v-model="item.endorsed"
            light
          ></v-select>

          <v-select
            :items="local.assets"
            label="Assets"
            multiple
            v-model.trim="item.assets"
            light
          ></v-select>

          <v-select
            :items="local.websites"
            label="Websites"
            multiple
            v-model.trim="item.websites"
            light
          ></v-select>
        </v-col>
      </v-row>
    </div>

    <div class="d-flex justify-end align-center pr-3">
      <v-btn @click="submit" small color="amber" class="mr-2" light
        >Change</v-btn
      >
      <v-btn @click="cancel" small color="grey" class="" light>Cancel</v-btn>
    </div>
  </div>
</template>

<script>
import { itemModel } from "./model";

export default {
  name: "NameSystemForm",
  components: {},
  props: {
    newItem: {
      type: Object,
      default: () => {},
    },
    colors: {
      type: Array,
      default: () => [],
    },
    local: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      item: this.createItem(this.newItem),
      panel: [0, 1],
      endorsementItems: ["Parent", "Master", "None"],
      brandItems: ["Brand", "Sub-brand", "Standalone", "Label"],
    };
  },
  methods: {
    createItem(item) {
      const proto = {};
      Object.keys(itemModel).forEach((key) => {
        proto[key] = item[key] ? item[key] : itemModel[key];
      });
      return proto;
    },
    submit() {
      this.$emit("submit", this.item);
    },
    cancel() {
      this.$emit("cancel", this.item);
    },
  },
};
</script>
